import React from 'react'
import styles from '../index.module.scss'
import InputCustom from '../../atoms/input/InputCustom'
import SelectCustom from '../../atoms/select/SelectCustom'
import { Grid } from '@mui/material'

const MakeupArtist = () => {
	return (
		<>
			<div>
				<h3 className={styles.Title}>Makeup Artist Survey</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="companyContactName"
								className={styles.label}
							>
								Company contact name
							</label>
							<InputCustom
								id="companyContactName"
								name="companyContactName"
								placeholder="Enter Company contact name"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="companyContactNumber"
								className={styles.label}
							>
								Company Contact Number
							</label>
							<InputCustom
								id="companyContactNumber"
								name="companyContactNumber"
								placeholder="Enter Company Contact Number"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="gettingReadyLocation"
								className={styles.label}
							>
								Getting ready location
							</label>
							<InputCustom
								id="gettingReadyLocation"
								name="gettingReadyLocation"
								placeholder="Enter getting ready location"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="numberOfPeopleGettingMakeupDone"
								className={styles.label}
							>
								Number of people getting makeup done
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Bride(s)', label: 'Bride(s)' },
									{
										value: 'Bridesmaids',
										label: 'Bridesmaids',
									},
									{
										value: 'Familymembers/others',
										label: 'Family members/others',
									},
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="numberOfMakeupArtistsOnTeam"
								className={styles.label}
							>
								Number of artists on team
							</label>
							<InputCustom
								id="numberOfMakeupArtistsOnTeam"
								name="numberOfMakeupArtistsOnTeam"
								placeholder="Enter number of artists on team"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Schedule Details</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="estimatedTimeForMakeupArtist"
								className={styles.label}
							>
								Estimated time for (enter bride’s preferred
								name)
							</label>
							<InputCustom
								id="estimatedTimeForMakeupArtist"
								name="estimatedTimeForMakeupArtist"
								placeholder="Enter estimated time for (enter bride’s preferred name)"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="estimatedTimePerMakeupArtist"
								className={styles.label}
							>
								Estimated time per additional person
							</label>
							<InputCustom
								id="estimatedTimePerMakeupArtist"
								name="estimatedTimePerMakeupArtist"
								placeholder="Enter estimated time per additional person"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label htmlFor="startTime" className={styles.label}>
								Start time
							</label>
							<InputCustom
								id="startTime"
								name="startTime"
								placeholder="Enter start time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="completionTime"
								className={styles.label}
							>
								Completion time
							</label>
							<InputCustom
								id="completionTime"
								name="completionTime"
								placeholder="Enter completion time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="willStayForTouchUps"
								className={styles.label}
							>
								Will you stay for touch-ups?
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Dependencies</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="coordinationWithMakeupArtist"
								className={styles.label}
							>
								Coordination with hair stylist?
							</label>
							<SelectCustom
								id="coordinationWithMakeupArtist"
								name="coordinationWithMakeupArtist"
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="lightingOrSpaceRequirements"
								className={styles.label}
							>
								Lighting or space requirements?
							</label>
							<InputCustom
								id="lightingOrSpaceRequirements"
								name="lightingOrSpaceRequirements"
								placeholder="Enter"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Notes</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="uploadScheduleOrProductList"
								className={styles.label}
							>
								Upload schedule or product list (optional)
							</label>
							<InputCustom
								id="uploadScheduleOrProductList"
								name="uploadScheduleOrProductList"
								placeholder="Enter notes"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Other Questions</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="rainContingencyOrSetupChangeNeeded"
								className={styles.label}
							>
								Rain contingency or setup change needed?
							</label>
							<InputCustom
								id="rainContingencyOrSetupChangeNeeded"
								name="rainContingencyOrSetupChangeNeeded"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="setupTeardownDuration"
								className={styles.label}
							>
								Setup / teardown duration
							</label>
							<InputCustom
								id="setupTeardownDuration"
								name="setupTeardownDuration"
								placeholder="Enter details"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="specialEquipmentOrSpaceNeeds"
								className={styles.label}
							>
								Special equipment or space needs?
							</label>
							<InputCustom
								id="specialEquipmentOrSpaceNeeds"
								name="specialEquipmentOrSpaceNeeds"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="contactForDayOfEmergencies"
								className={styles.label}
							>
								Contact for day-of emergencies
							</label>
							<InputCustom
								id="contactForDayOfEmergencies"
								name="contactForDayOfEmergencies"
								placeholder="Enter contact for day-of emergencies"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}

export default MakeupArtist
